module.exports = __webpack_public_path__ + "img/cooperation_2.aed1efb2.png";